<!--
 * @Author: zhangjingqing
 * @Date: 2022-02-11 14:47:55
 * @LastEditors: zhangjinqing
 * @LastEditTime: 2022-06-19 18:59:35
 * @Description: file content
 * @FilePath: \lcdp-front-web\src\components\UserMenu.vue
-->
<template>
  <div class="user-wrapper">
    <header-notice class="action" />
    <a-dropdown>
      <span class="action action-full ant-dropdown-link user-dropdown-menu">
        <a-avatar class="avatar" size="" icon="user" />
        <span>欢迎您，{{ userInfo.realname }}</span>
      </span>
      <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
        <a-menu-item key="2">
          <a href="javascript:;" @click="handleUpdatePsd(userInfo.id)">
            <a-icon style="margin-right: 8px" type="setting" />
            <span>修改密码</span>
          </a>
          <br>
          <a href="javascript:;" @click="handleLogout">
            <a-icon style="margin-right: 8px" type="poweroff" />
            <span>退出登录</span>
          </a>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <password-modal ref="passwordModal"></password-modal>

  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import PasswordModal from "../views/userManage/user/components/PasswordModal";
export default {
  name: "UserMenu",
  methods: {
    ...mapActions(["Logout"]),
    handleLogout() {
      this.Logout();
    },
    handleUpdatePsd(id) {
      this.$refs.passwordModal.show(id);
    },
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  components: { PasswordModal},
};
</script>
<style lang="less" scoped>
</style>
